/*-------------------- beard-collection-new-list----------------------*/
class ComboCollSlider {
  constructor (parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.collection-combo-js');
    sliders?.forEach(element => {
      let noOfProducts = qs(".no-of-products",element).value;
      let CollSliderSectionId = element.dataset.id;
      let CollSliderSlide = element.dataset.slide;
      let CollSliderClass = `.collection-combo-js.${CollSliderSectionId}`;
      if(noOfProducts > 3 && screen.width > 767) {
        this.ComboCollSlider(CollSliderClass,CollSliderSlide);
      }
      if(noOfProducts > 2 && screen.width < 768) {
        this.ComboCollSlider(CollSliderClass,CollSliderSlide);
      }
    });
  }
  ComboCollSlider = (sliderClass,CollSliderSlide) => {
    new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 4,
      slidesPerGroup: 1,
      autoHeight:true,
      speed: 1000,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true
      },
      breakpoints: {
        1: {
          slidesPerView: 2,
          spaceBetween: 10,
          autoHeight:false,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

new ComboCollSlider(qs('.collection-combo-wrapper-js'));